"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUsersLight(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M14.798 17.537c2.276 0 2.688 2.696 2.688 4.451 0 1.259-.831 2.012-2.074 2.012h-6.79c-1.242 0-2.073-.753-2.073-2.012 0-1.755.411-4.45 2.687-4.45.264 0 1.228 1.079 2.781 1.079 1.554 0 2.517-1.08 2.781-1.08zm-9.275-3.48c.163 0 .971.66 2.02.66.357 0 .699-.062 1.033-.178-.023.17-.039.342-.039.512 0 .707.225 1.406.63 1.989a2.75 2.75 0 00-2.06.994h-1.04c-.777 0-1.507-.373-1.507-1.235l.001-.298c.009-.826.1-2.444.962-2.444zm6.494-1.988a2.984 2.984 0 11-.001 5.967 2.984 2.984 0 01.001-5.967zm6.494 1.988c.987 0 .963 2.113.963 2.742 0 .862-.73 1.235-1.507 1.235h-1.04a2.75 2.75 0 00-2.059-.994 3.51 3.51 0 00.63-1.989c0-.17-.016-.341-.04-.512.334.116.676.178 1.033.178 1.05 0 1.857-.66 2.02-.66zM7.543 10.08c1.095 0 1.988.893 1.988 1.989a1.992 1.992 0 01-1.988 1.988 1.992 1.992 0 01-1.989-1.988c0-1.096.894-1.989 1.989-1.989zm8.948 0c1.096 0 1.989.893 1.989 1.989a1.992 1.992 0 01-1.989 1.988 1.992 1.992 0 01-1.988-1.988c0-1.096.893-1.989 1.988-1.989zM12.08 0c1.581 0 3.2 1.1 3.2 2.8 0 .644-.212 1.2-.644 1.675-.431.475-1 1.144-1.05 1.813a.6.6 0 01.294.512c0 .15-.056.294-.156.4.1.106.156.25.156.4a.6.6 0 01-.281.506.61.61 0 01.081.294c0 .406-.319.6-.681.6-.163.363-.525.6-.919.6s-.756-.237-.919-.6c-.362 0-.681-.194-.681-.6 0-.1.031-.206.081-.294a.6.6 0 01-.281-.506c0-.15.056-.294.156-.4a.584.584 0 01-.156-.4.6.6 0 01.294-.513c-.05-.668-.619-1.337-1.05-1.812A2.405 2.405 0 018.88 2.8c0-1.7 1.619-2.8 3.2-2.8zm0 .8c-1.131 0-2.4.75-2.4 2 0 .4.162.819.425 1.125.119.138.256.269.381.413.444.53.819 1.156.881 1.862h1.425c.063-.706.438-1.331.882-1.862.125-.144.262-.276.381-.413.263-.306.425-.725.425-1.125 0-1.25-1.269-2-2.4-2zm0 1c.581 0 1.4.306 1.4 1 0 .106-.094.2-.2.2a.206.206 0 01-.2-.2c0-.431-.669-.6-1-.6a.206.206 0 01-.2-.2c0-.106.094-.2.2-.2z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgUsersLight;
exports.default = _default;